import * as React from 'react';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

const DEFAULT_EMPTY_MESSAGE = 'No conversations here!';

type Props = {
    readonly message?: React.ReactNode;
    readonly testid?: string;
};

const NoConversations = ({ message = DEFAULT_EMPTY_MESSAGE, testid = 'messengerNoConversations' }: Props) => {
    return (
        <StyledNoConversations data-testid={testid}>
            <H4>{message}</H4>
        </StyledNoConversations>
    );
};

const StyledNoConversations = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 23px 32px 24px;
    background-color: ${({ theme }) => theme.colors.grey500};
    border: solid 1px ${({ theme }) => theme.colors.grey400};
`;

export default React.memo<Props>(NoConversations);
